var map = {
	"./CM.png": 77368,
	"./CPO.png": 56062,
	"./agentkaimain.png": 69683,
	"./avatars/shivam.png": 16159,
	"./awards.png": 26450,
	"./bgSS.png": 41747,
	"./bgfoot.png": 75725,
	"./bggenai.png": 12505,
	"./bgsd.png": 12652,
	"./buybarg.png": 14820,
	"./cm_title_category.png": 77444,
	"./csv.png": 31826,
	"./cubeicon.png": 70620,
	"./dos.png": 67552,
	"./eb.png": 81133,
	"./generatebutton.png": 51521,
	"./gs.png": 93186,
	"./ior.png": 25796,
	"./kai.png": 63319,
	"./kai2.png": 37605,
	"./kai3.png": 54716,
	"./klogo.png": 22184,
	"./mainbg1.png": 2133,
	"./robo.png": 59052,
	"./source.png": 2343,
	"./supbarg.png": 20448,
	"./supro.png": 59671,
	"./uploadicon.png": 71160,
	"./xlsx.png": 37985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50715;